import React, { useState } from "react";

import { CNav, CNavItem, CNavLink } from "@coreui/react";

import "./styles.css";

/**
 * RANKING DA TURMA — a tabela, e só ela.
 *
 * Este componente não busca nada: recebe as duas listas já ordenadas e
 * posicionadas pelo servidor. É de propósito, porque as duas telas que o usam
 * têm molduras diferentes (o professor abre num modal com o interruptor de
 * liberação; o aluno vê numa aba da turma) e nenhuma das duas deveria repetir
 * regra de ordenação — se cada ponta ordenasse por conta, professor e aluno
 * poderiam ver colocações diferentes para o mesmo empate.
 *
 * As DUAS VISÕES mostram as mesmas colunas, mudando qual está em destaque e
 * por qual a lista está ordenada. Esconder a outra métrica só faria o aluno
 * alternar as abas para responder "e as minhas conquistas?".
 */

const VISOES = [
  { id: "xp", rotulo: "Por XP total" },
  { id: "achievements", rotulo: "Por conquistas" }
];

/* Ouro, prata e bronze — só as três primeiras colocações ganham cor. */
const CLASSE_POR_POSICAO = {
  1: "ranking-medalha-ouro",
  2: "ranking-medalha-prata",
  3: "ranking-medalha-bronze"
};

function Ranking({ data, highlightUserId }) {
  const [visao, setVisao] = useState("xp");

  const linhas = (data && data[visao]) || [];

  return (
    <div className="ranking">
      <CNav variant="tabs" className="ranking-visoes">
        {VISOES.map(item => (
          <CNavItem key={item.id}>
            <CNavLink
              active={visao === item.id}
              onClick={() => setVisao(item.id)}
            >
              {item.rotulo}
            </CNavLink>
          </CNavItem>
        ))}
      </CNav>

      {linhas.length === 0 ? (
        <div className="text-muted p-3">
          Nenhum aluno nesta turma para exibir no ranking.
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table ranking-table">
            <thead>
              <tr>
                <th className="ranking-coluna-posicao">#</th>
                <th>Aluno</th>
                <th
                  className={`ranking-coluna-valor ${
                    visao === "xp" ? "ranking-coluna-ativa" : ""
                  }`}
                >
                  XP total
                </th>
                <th className="ranking-coluna-valor">Nível</th>
                <th
                  className={`ranking-coluna-valor ${
                    visao === "achievements" ? "ranking-coluna-ativa" : ""
                  }`}
                >
                  Conquistas
                </th>
              </tr>
            </thead>
            <tbody>
              {linhas.map(linha => (
                <tr
                  key={linha.user_id}
                  className={
                    linha.user_id === highlightUserId ? "ranking-eu" : ""
                  }
                >
                  <td data-label="#" className="ranking-coluna-posicao">
                    <span
                      className={`ranking-posicao ${
                        CLASSE_POR_POSICAO[linha.position] || ""
                      }`}
                    >
                      {linha.position}
                    </span>
                  </td>
                  <td data-label="Aluno">{linha.name}</td>
                  <td
                    data-label="XP total"
                    className={`ranking-coluna-valor ${
                      visao === "xp" ? "ranking-coluna-ativa" : ""
                    }`}
                  >
                    {linha.xp}
                  </td>
                  <td data-label="Nível" className="ranking-coluna-valor">
                    {linha.level}
                  </td>
                  <td
                    data-label="Conquistas"
                    className={`ranking-coluna-valor ${
                      visao === "achievements" ? "ranking-coluna-ativa" : ""
                    }`}
                  >
                    {linha.achievements}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Ranking;
